import React from 'react';
import { Typography } from "@material-ui/core";
import { Parallax } from "react-scroll-parallax";
import AppearingElement from '../Helper/AppearingElement';
import './main.css';

// Landing Pages Sections 6B and 2D combined
function CombinedBarSection(props) {
    return (
        <section className="bar-section-pendo">
            <div className="bar-section__background-pendo" />
            <section className="bar-info-section-pendo">
                <div className="bar-info-section__header-pendo">
                    {!props.hideParallax &&
                        <AppearingElement variant="fade-in">
                            <Parallax y={[-50, 5]}>
                                <Typography variant="h3">
                                    {props.header}
                                </Typography>
                            </Parallax>
                        </AppearingElement>
                    }
                    {props.hideParallax &&
                        <AppearingElement variant="zoom-down">
                            <Typography variant="h3">
                                {props.header}
                            </Typography>
                        </AppearingElement>
                    }
                </div>
                <div className="bar-info-section__content-pendo">
                    {!props.hideParallax &&
                        <AppearingElement variant="fade-in">
                            <Parallax y={[20, -50]}>
                                <Typography variant="h5">
                                    {props.content}
                                </Typography>
                            </Parallax>
                        </AppearingElement>
                    }
                    {props.hideParallax &&
                        <AppearingElement variant="zoom-down">
                            <Typography variant="h5">
                                {props.content}
                            </Typography>
                        </AppearingElement>
                    }
                </div>
                <img alt="Zip Editor Screenshot" src={props.image} className="bar-info-section__graphic" />
            </section>
        </section>
    );
}

export default CombinedBarSection;